import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: gives the page editor a "Pages" crumb that links back to the list. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/content/pages')({
  staticData: { crumb: 'common:nav.pages' },
  component: Outlet,
});
